// constants
import { RangeDefActionTypes } from './constants';
import { RangeDef as RangeDefData } from 'src/types/rangeDef';

export type RangeDefActionType = {
    type:
        | RangeDefActionTypes.API_RESPONSE_SUCCESS
        | RangeDefActionTypes.API_RESPONSE_ERROR
        | RangeDefActionTypes.ADD_RANGE_DEF
        | RangeDefActionTypes.EDIT_RANGE_DEF
        | RangeDefActionTypes.GET_RANGE_DEF
        | RangeDefActionTypes.GET_RANGE_DEFS
        | RangeDefActionTypes.RESET
        | RangeDefActionTypes.RESET_SUCCESS
        | RangeDefActionTypes.RESET_ERROR;
    payload: {} | string;
};

// common success
export const rangeDefApiResponseSuccess = (
    actionType: string,
    data: RangeDefData | {},
    message: string,
    code: number,
    error: string | boolean,
    success: boolean
): RangeDefActionType => ({
    type: RangeDefActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data, message, code, error, success },
});
// common error
export const rangeDefApiResponseError = (
    actionType: string,
    data: RangeDefData | {},
    message: string,
    code: number,
    error: string | boolean,
    success: boolean
): RangeDefActionType => ({
    type: RangeDefActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, data, message, code, error, success },
});

export const addRangeDef = (params: any): RangeDefActionType => ({
    type: RangeDefActionTypes.ADD_RANGE_DEF,
    payload: params,
});

export const editRangeDef = (params: any): RangeDefActionType => ({
    type: RangeDefActionTypes.EDIT_RANGE_DEF,
    payload: params,
});

export const GetRangeDefs = (params: any): RangeDefActionType => ({
    type: RangeDefActionTypes.GET_RANGE_DEFS,
    payload: params,
});

export const GetRangeDef = (params: any): RangeDefActionType => ({
    type: RangeDefActionTypes.GET_RANGE_DEF,
    payload: params,
});

export const resetRangeDef = (): RangeDefActionType => ({
    type: RangeDefActionTypes.RESET,
    payload: {},
});

export const resetRangeDefSuccess = (): RangeDefActionType => ({
    type: RangeDefActionTypes.RESET_SUCCESS,
    payload: {},
});
export const resetRangeDefError = (): RangeDefActionType => ({
    type: RangeDefActionTypes.RESET_ERROR,
    payload: {},
});
